import React, {Component} from 'react';

import Core from './../Core/Core';

import {GoogleLogin, GoogleLogout} from 'react-google-login';

import logo from './../Static/logo-weeflow.png';

class Header extends Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            "flash_access" : false,
        };

        this.checkPermisions();
    }

    checkPermisions(){
        let user = JSON.parse(localStorage.getItem("User"));
        if(user && user.email){
            Core.Instance.Request(Core.Address+"GetUserFromEmail/?email="+user.email, null, "GET")
            .then((json) => {
                if(json && json[0]){
                    this.setState({
                        "flash_access" : json[0].flash_access ? true : false
                    })
                }else{
                    this.setState({
                        "flash_access" : false
                    })
                }
            });
        }
    }

    render()
    {
        return (
            <header>
                <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top border-bottom py-0">
                    <a className="navbar-brand py-0" href="/search">
                        <img src={ logo } style={{ "height" : "50px" }} />
                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarText">
                        <ul className="navbar-nav mr-auto py2-1 mb-0">
                            <a className={ "nav-item nav-link "+((window.location.href.indexOf("/search") != -1 || window.location.href.split("/")[3] == "" ) ? "active" : "") } href={Core.Instance.user != null ? "/search" : "#"}  >Recherche</a>
                            <a className={ "nav-item nav-link "+(window.location.href.indexOf("/geo") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/geo" : "#"} >Géolocalisation</a>
                            <a className={ "nav-item nav-link "+(window.location.href.indexOf("/user") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/users" : "#"} >Administration</a>
                            <a className={ "nav-item nav-link "+(window.location.href.indexOf("/rework") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/rework" : "#"} >Conflits</a>
                            <a className={ "nav-item nav-link "+(window.location.href.indexOf("/alert") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/alert" : "#"} >Alertes</a>
                            <a className={ "nav-item nav-link "+(window.location.href.indexOf("/scan") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/scan" : "#"} target="_blank" >Scan</a>
                            <a className={ "nav-item nav-link "+(window.location.href.indexOf("/proposal") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/proposal" : "#"} >Propositions</a>
                            {   this.state.flash_access &&
                                <React.Fragment>
                                    <a className={ "nav-item nav-link "+(window.location.href.indexOf("/flash") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/flash" : "#"} >Flash</a>
                                    <a className={ "nav-item nav-link "+(window.location.href.indexOf("/conseilor") != -1 ? "active" : "") } href={Core.Instance.user != null ? "/conseilor" : "#"} >Vendeurs</a>
                                </React.Fragment>
                            }
                        </ul>
                        <span className="navbar-text p-0">
                            { this.props.buttons }
                            {
                                Core.Instance.user == null &&
                                <GoogleLogin
                                    clientId="784569189888-bf6jj2psgrj5h6povq7jofhue4v7crnh.apps.googleusercontent.com"
                                    buttonText="Se connecter"
                                    onSuccess={Core.Instance.OnSignIn}
                                    onFailure={Core.Instance.OnSignIn}
                                    className="loginBtn loginBtn--google ml-4"
                                />
                            }
                            {
                                Core.Instance.user != null &&
                                <button className="btn btn-outline-secondary ml-4" onClick={ Core.Instance.OnSignOut } ><li className="fas fa-sign-out-alt"> </li> Se déconnecter</button>
                            }
                        </span>
                    </div>


                </nav>
            </header>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Components/Header.js